import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {AchatsService, Recap, WindowRefService, SiteInfosService} from '@app/core';
import {size, find} from 'lodash';

@Component({
    selector: 'app-mode-paiement',
    templateUrl: './mode-paiement.component.html',
    styleUrls: ['./mode-paiement.component.scss']
})
export class ModePaiementComponent implements OnChanges, OnDestroy {

  modePayment : any = {
    id: 100,
    name: 'siteweb',
  };
  private paymentList : Array<any>;
  @Input() resa2 : Boolean = false;
  @Input() paymentInfos : any;
  private confirmed : Boolean = false;
  private stripeToggledVal : Number = 0;
  private paypalToggledVal : Number = 0;
  private pciToggledVal : Number = 0;
  private cmiToggledVal : Number = 0;
  private payzoneToggledVal : Number = 0;
  private virementelectroniqueToggledVal : any;
  private readonly  idPCI = 4;//todo: use const
  recapModel: Recap = new Recap();
  
  constructor(private winRef: WindowRefService, public achatService: AchatsService, private siteInfosService: SiteInfosService) {
  }
            
  ngOnChanges(changes: SimpleChanges): void {
    const paymentInfos = changes.paymentInfos;
    if (paymentInfos && typeof paymentInfos === 'object' && paymentInfos.currentValue){
      this.modePayment = {
        id: parseInt(Object.keys(paymentInfos.currentValue)[0])
      };
        if (size(paymentInfos.currentValue[this.modePayment.id].info) == 1 && this.modePayment.id !== this.idPCI) {
            let item = find(this.achatService.extraPayments, {id: parseInt(this.modePayment.id)});
            this.togglePayment(item.name, paymentInfos.currentValue[this.modePayment.id].info[0]);
        }
    }
  }

  private select(newItem) {
    this.paymentList = this.achatService.paymentTypesList;
    this.paymentList.forEach(item => {
        if (item.id === newItem.id){
          this.modePayment = item;
        }
    });
    
    if (size(newItem.payement) == 1 && newItem.id !== this.idPCI ) {
        this.togglePayment(newItem.name, newItem.payement[0]);
    }
  }
  private confirm() {
    this.confirmed = true;
  }

  ngOnDestroy(){
    this.paymentList = [];
    this.paymentInfos = null;
  }

  private togglePayment(type, val){
    switch (type) {
      case 'stripe' :
        this.stripeToggledVal = val;
        console.log(val);
        break;
      case 'paypal' :
        this.paypalToggledVal = val;
        break;
      case 'pci' :
        this.pciToggledVal = val;
        break;
      case 'cmi' :
        this.cmiToggledVal = val;
        break;
      case 'payzone' :
        this.payzoneToggledVal = val;
        break;
      case 'static.virementelectronique' :
        this.virementelectroniqueToggledVal = val;
        break;
      default:
        break;
    }
  }

  private submitCMI(){
    (<HTMLFormElement>document.getElementById('form_cmi_' + this.cmiToggledVal)).submit();
  }

  /**
   * get taux de change
   * @returns number
   */
  get Cpercente(): number {
    return this.winRef.appConfigSite.Cpercente;
  }

  /**
   * get currency
   * @returns string
   */
  get Ccurrency(): string {
    return this.winRef.appConfigSite.Ccurrency;
  }


  get canconfirm(): Boolean {
    return [6, 7, 8].indexOf(this.modePayment.id) !== -1;
  }
    
}
